"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountSourceTypeToJSON = exports.AdAccountSourceTypeFromJSONTyped = exports.AdAccountSourceTypeFromJSON = exports.AdAccountSourceType = void 0;
/**
 * The internal service that created the ad account.
 * @export
 */
exports.AdAccountSourceType = {
    AD_STUDIO: 'AD_STUDIO',
    S4A: 'S4A',
    STRATEGIC_PROMOTION: 'STRATEGIC_PROMOTION',
    MEGAPHONE_CMS: 'MEGAPHONE_CMS',
    MEGAPHONE_MAPPER: 'MEGAPHONE_MAPPER',
    SALESFORCE: 'SALESFORCE'
};
function AdAccountSourceTypeFromJSON(json) {
    return AdAccountSourceTypeFromJSONTyped(json, false);
}
exports.AdAccountSourceTypeFromJSON = AdAccountSourceTypeFromJSON;
function AdAccountSourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdAccountSourceTypeFromJSONTyped = AdAccountSourceTypeFromJSONTyped;
function AdAccountSourceTypeToJSON(value) {
    return value;
}
exports.AdAccountSourceTypeToJSON = AdAccountSourceTypeToJSON;
